"use client";
import {
  PublicationCard,
  PublicationCardsBlockProps,
} from "@/page-builder/fragments/PublicationCardsBlock/types";
import Image from "@/components/atoms/image";
import { useEffect, useState } from "react";
import WrapperBlueStyle from "@/components/atoms/wrapper-blue-style";
import { Link } from "@/i18n/navigation";
import { Icon } from "@ama-pt/agora-design-system";

export const PublicationCardsContent = ({
  cards,
}: PublicationCardsBlockProps) => {
  return (
     <WrapperBlueStyle>
      <div className="container mx-auto grid xs:grid-cols-1 md:grid-cols-1 xl:grid-cols-3 gap-32">
        {cards?.map((item: PublicationCard, index: number) => (
          <VideoCard key={index} {...item} />
        ))}
      </div>
    </WrapperBlueStyle>
  );
};

const VideoCard = ({
  image,
  title,
  description,
  target,
  url,
}: PublicationCard) => {
  const [isHovered, setIsHovered] = useState(false);
  const [isTablet, setIsTablet] = useState(false);

  useEffect(() => {
    const handleResize = () => {
      setIsTablet(window.innerWidth >= 768 && window.innerWidth < 1280);
    };

    handleResize();

    window.addEventListener("resize", handleResize);

    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, []);

  return (
    <Link href={url as any} target={target || "_blank"} >
    <div
      className={`relative w-full h-full flex ${
        isTablet ? "flex-row" : "flex-col"
      } transition-all duration-200 ${isHovered ? "group" : ""}`}
      onMouseEnter={() => setIsHovered(true)}
      onMouseLeave={() => setIsHovered(false)}
    >
        <div
          style={{
            width: isTablet ? "40%" : "calc(100% - 24px)",
            height: isTablet ? "calc(100% - 24px)" : "auto",
            marginBottom: isTablet ? "24px" : "0",
          }}
          className={`relative`}
        >
          
          <Image
            src={image?.src || ""}
            alt={""}
            width={640}
            height={320}
            className="w-full min-w-[280px] h-full object-cover"
          />
          <div className="absolute inset-0 z-20 opacity-0 group-hover:opacity-100 transition-opacity bg-bupi-hoverGradient pointer-events-none" />
          
        </div>

        <div
          className={`${
            isTablet
              ? "mt-16 -ml-32 pl-48 py-24 flex flex-row items-center justify-between gap-16"
              : "px-24 py-16 ml-16 flex flex-col"
          } bg-white flex-grow justify-between `}
        >
          <div className={`${isTablet ? "w-1/2 mx-16" : "w-full"}`}>
            <h2 className="text-l-bold text-neutral-900">{title}</h2>

            <p className="text-m-regular text-neutral-900 mt-8 flex-grow">
              {description}
            </p>
          </div>

          <div className={`${isTablet ? "mx-24" : "w-full"} mt-16`}>
            <Icon name="agora-line-arrow-right-circle" />
          </div>
        </div>
    </div>
    </Link>
  );
};
